import styled from 'styled-components';

export const MerchantCustomerWrapper = styled.div``;
